import React from "react";
import SEO from "@/components/SEO";
import { RESTAURANT } from "@/lib/restaurant";

export default function Confidentialite() {
  return (
    <div data-testid="confidentialite-page" className="pt-32 pb-20">
      <SEO
        title="Politique de confidentialité"
        description={`Politique de confidentialité de ${RESTAURANT.name} : collecte et traitement des données personnelles, RGPD.`}
        path="/confidentialite"
      />
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="eyebrow">Privacidade & dados</div>
        <h1 className="text-5xl md:text-6xl mt-3 mb-10">Politique de <em className="italic text-[#C04E38]">confidentialité</em></h1>

        <article className="space-y-8">
          <section>
            <h2 className="text-2xl mb-3">1. Responsable du traitement</h2>
            <p className="text-[#5C5A56] leading-relaxed">
              Le responsable du traitement des données collectées sur ce site est <b>{RESTAURANT.legalName}</b>,
              {RESTAURANT.legal.legalForm}, dont le siège social est situé {RESTAURANT.legal.legalAddress}
              (SIRET {RESTAURANT.legal.siret}). Contact : <a href={`mailto:${RESTAURANT.email}`} className="text-[#C04E38]">{RESTAURANT.email}</a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3">2. Données collectées</h2>
            <p className="text-[#5C5A56] leading-relaxed mb-3">Nous collectons uniquement les données nécessaires au traitement de votre demande :</p>
            <ul className="text-[#5C5A56] space-y-1 list-disc list-inside">
              <li><b className="text-[#2C2B29]">Réservation</b> : nom, email, téléphone, date, heure, nombre de couverts</li>
              <li><b className="text-[#2C2B29]">Privatisation</b> : nom, email, téléphone, type d'événement, date, nb de personnes, budget, besoins, message</li>
              <li><b className="text-[#2C2B29]">Contact</b> : nom, email, sujet, message</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl mb-3">3. Finalités</h2>
            <ul className="text-[#5C5A56] space-y-1 list-disc list-inside">
              <li>Traitement de votre demande de réservation, privatisation ou contact</li>
              <li>Confirmation par email</li>
              <li>Communication ponctuelle relative à votre demande (rappel, modification, annulation)</li>
            </ul>
            <p className="text-[#5C5A56] leading-relaxed mt-3">
              Aucune finalité commerciale tierce. Aucune revente de données. Aucun envoi de newsletter
              sans consentement explicite.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3">4. Base légale</h2>
            <p className="text-[#5C5A56] leading-relaxed">
              Le traitement repose sur l'<b>exécution de mesures précontractuelles</b> prises à votre
              demande (article 6.1.b RGPD) et sur notre <b>intérêt légitime</b> à répondre aux demandes
              clients (article 6.1.f RGPD).
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3">5. Durée de conservation</h2>
            <ul className="text-[#5C5A56] space-y-1 list-disc list-inside">
              <li>Réservations / privatisations : 3 ans à compter de la dernière interaction</li>
              <li>Messages de contact : 3 ans</li>
              <li>Données comptables (factures) : 10 ans (obligation légale)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl mb-3">6. Destinataires</h2>
            <p className="text-[#5C5A56] leading-relaxed">
              Vos données sont strictement réservées au personnel habilité de {RESTAURANT.name}.
              Elles peuvent transiter par <b>Google (Gmail SMTP)</b> pour l'envoi des emails de confirmation
              et sont stockées sur l'infrastructure cloud de l'éditeur en France / Union Européenne.
              Aucun transfert hors UE n'est effectué.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3">7. Vos droits</h2>
            <p className="text-[#5C5A56] leading-relaxed mb-3">Conformément au RGPD, vous disposez des droits suivants :</p>
            <ul className="text-[#5C5A56] space-y-1 list-disc list-inside">
              <li>Droit d'accès, de rectification et d'effacement</li>
              <li>Droit à la limitation et à la portabilité</li>
              <li>Droit d'opposition</li>
              <li>Droit d'introduire une réclamation auprès de la CNIL (<a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#C04E38]">www.cnil.fr</a>)</li>
            </ul>
            <p className="text-[#5C5A56] leading-relaxed mt-3">
              Pour exercer vos droits, écrivez à <a href={`mailto:${RESTAURANT.email}`} className="text-[#C04E38]">{RESTAURANT.email}</a>
              en précisant l'objet de votre demande. Une réponse vous sera apportée sous 30 jours.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3">8. Cookies</h2>
            <p className="text-[#5C5A56] leading-relaxed">
              Le site utilise uniquement des cookies de session strictement nécessaires (espace
              admin). Aucun cookie tiers de traçage publicitaire n'est déposé.
            </p>
          </section>
        </article>
      </div>
    </div>
  );
}
